(function () {

  // Mueve el boton "Calcular mi talla" de Kiwi al lado de las tallas.
  // Antes solo lo intentaba durante el primer segundo; si Kiwi tardaba mas
  // en cargar, el boton quedaba escondido. Ahora vigila la pagina y lo mueve
  // apenas aparece (y otra vez si el tema redibuja las tallas al cambiar de color).

  function moveKiwiButton() {
    // Boton real de Kiwi
    const kiwiBtn = document.querySelector(
      'button.ks-calculator-modal-button, button.sizing-calculator-modal-button'
    );

    if (!kiwiBtn) {
      return false;
    }

    // Buscar el fieldset de "Talla"
    const fieldsets = document.querySelectorAll('fieldset.variant-picker__option');
    let sizeFieldset = null;

    fieldsets.forEach(fs => {
      const legend = fs.querySelector('legend');
      const text = (legend?.textContent || '').toLowerCase();

      if (text.includes('talla') || text.includes('size')) {
        sizeFieldset = fs;
      }
    });

    if (!sizeFieldset) {
      return false;
    }

    const values = sizeFieldset.querySelector('.variant-picker__option-values');
    if (!values) {
      return false;
    }

    // Mover el boton justo al lado de las tallas
    if (!values.contains(kiwiBtn)) {
      values.appendChild(kiwiBtn);
    }

    return true;
  }

  // Estilo del boton junto a las tallas: boton negro con esquinas suaves e icono blanco (2026-10-26)
  function ponerEstilo() {
    if (document.getElementById('kiwi-estilo-5norte')) return;
    const b = 'fieldset.variant-picker__option button.ks-calculator-modal-button';
    const css = document.createElement('style');
    css.id = 'kiwi-estilo-5norte';
    css.textContent =
      b + '{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:auto!important;min-width:0!important;height:auto!important;min-height:0!important;box-shadow:none!important;align-self:center!important;cursor:pointer;margin:0 0 0 6px!important;line-height:1.2!important;border:0!important;border-radius:8px!important;background:#1c1c1c!important;padding:10px 16px!important;font-size:11px!important;letter-spacing:.14em!important;color:#fff!important}' +
      b + ' span.with-icon{padding:0!important;margin:0!important;display:inline-flex!important;align-items:center!important;gap:7px!important;background:none!important}' +
      b + ' .kiwi-svg{position:static!important;display:inline-block!important;width:16px!important;height:16px!important;margin:0!important;filter:invert(1)!important}';
    document.head.appendChild(css);
  }

  function run() {
    ponerEstilo();
    moveKiwiButton();

    // Vigilar la pagina: cada vez que cambia algo, revisar si hay que mover el boton
    let pendiente = false;
    const observer = new MutationObserver(() => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(() => {
        pendiente = false;
        moveKiwiButton();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
